import { LegendItemModel, PropertyFilterModel } from "models";

export const combineFiltersWithPriority = (
  currentFilter: PropertyFilterModel[],
  legendFilters: PropertyFilterModel[],
  legendItems: LegendItemModel[]
): PropertyFilterModel[] => {
  // Get source keys from legend filters (higher priority)
  const legendSourceKeys = new Set<string>();
  const legendRollupProperties = new Set<string>();
  const legendProperties = new Set<string>();
  legendFilters.forEach((filter) => {
    filter.predicates.forEach((predicate) => {
      legendProperties.add(predicate.property);
      if (predicate.rollup) {
        legendRollupProperties.add(predicate.property);
      } else if (predicate.sourceKey) {
        legendSourceKeys.add(predicate.sourceKey);
      }
    });
  });
  const itemsInLegendItems = legendItems.map((item: LegendItemModel) => {
    return item.title;
  });

  const validSourceKeys = new Set(itemsInLegendItems);

  // Filter out items from currentFilter that have duplicate source keys
  const filteredCurrentFilter = currentFilter
    .map((filterGroup) => ({
      ...filterGroup,
      predicates: filterGroup.predicates
        .filter((predicate) => {
          // A rollup predicate names no legend title, so only a new one replaces it. One on
          // another property stays in its own group, so keeping it here would repeat it.
          if (predicate.rollup) {
            return (
              legendProperties.has(predicate.property) &&
              !legendRollupProperties.has(predicate.property)
            );
          }
          // Keep predicate if it doesn't conflict with legend source keys
          const isNotInNewFilter = !(
            predicate.sourceKey && legendSourceKeys.has(predicate.sourceKey)
          );
          if (isNotInNewFilter) {
            return validSourceKeys.has(predicate.sourceKey);
          }
          return isNotInNewFilter;
        })
        .map((pred) => ({ ...pred }))
    }))
    .filter((filterGroup) => filterGroup.predicates.length > 0);

  const newLegendFilters = legendFilters.map((filter) => ({
    ...filter,
    predicates: filter.predicates.map((pred) => ({ ...pred }))
  }));

  return [...newLegendFilters, ...filteredCurrentFilter];
};
